import { FormFields } from '../../../../../models/newSupportCall';
import { useIntl } from 'react-intl';
import SupportCallOccurrenceFields from "../SupportCallOccurrenceFields";

export interface ICancellationFormData {
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
    name: string;
    fetchVehicle: (chassis: string) => Promise<void>;
    loadingLicensePlate?: boolean;
    occurrenceId?: string;
}

const fieldColumnClassName = 'form-group form-group-lg flex-1-1';

const CancellationForm = ({ formData, errors, updateField, name, fetchVehicle, loadingLicensePlate, occurrenceId }: ICancellationFormData) => {
    const intl = useIntl();
    return (
        <>
            <SupportCallOccurrenceFields
                formData={formData}
                errors={errors}
                updateField={updateField}
                name={name}
                fetchVehicle={fetchVehicle}
                subject="CONTRACT_CANCELLATION"
                loadingLicensePlate={loadingLicensePlate}
                occurrenceId={occurrenceId}
            />
            <div className='margin-top-20'>
                <p className='text-size-16 text-bold'>{intl.formatMessage({ id: 'intl-msg:support.administrative.additionalDataTitle' })}</p>
                <div className='padding-15 margin-top-20 rounded border'>
                    <div className='display-flex gap-20'>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>{intl.formatMessage({ id: 'intl-msg:support.constants.field.contractNumber' })} *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder={intl.formatMessage({ id: 'intl-msg:occurrence.required' })}
                                value={formData.contractNumber}
                                onChange={event => updateField('contractNumber', event.target.value)}
                            />
                            {errors.contractNumber ? <span className='text-size-12 text-color-danger'>{errors.contractNumber}</span> : null}
                        </div>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>{intl.formatMessage({ id: 'intl-msg:support.constants.field.vehicleQtd' })} *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder={intl.formatMessage({ id: 'intl-msg:occurrence.required' })}
                                value={formData.vehicleQtd}
                                onChange={event => updateField('vehicleQtd', event.target.value)}
                            />
                            {errors.vehicleQtd ? <span className='text-size-12 text-color-danger'>{errors.vehicleQtd}</span> : null}
                        </div>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>{intl.formatMessage({ id: 'intl-msg:support.constants.field.cancelReason' })} *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder={intl.formatMessage({ id: 'intl-msg:occurrence.required' })}
                                value={formData.cancelReason}
                                onChange={event => updateField('cancelReason', event.target.value)}
                            />
                            {errors.cancelReason ? <span className='text-size-12 text-color-danger'>{errors.cancelReason}</span> : null}
                        </div>
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>{intl.formatMessage({ id: 'intl-msg:support.constants.field.cancelComment' })} *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder={intl.formatMessage({ id: 'intl-msg:occurrence.required' })}
                            value={formData.cancelComment}
                            onChange={event => updateField('cancelComment', event.target.value)}
                        />
                        {errors.cancelComment ? <span className='text-size-12 text-color-danger'>{errors.cancelComment}</span> : null}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CancellationForm;
